export default __webpack_public_path__ + "static/July4Popup-980b605152300f15b3079ac829d1c57d.jpg";